import { posthogEventEmitter } from "./posthogEventEmitter";
import { getEngageAttributionProps } from "./engageAttribution";
import { APP_EVENTS } from "@Utils/webApputils/analyticEvents";
import { logAppEvent } from "@Utils/appAnalytics";
import { getSearchRecommendationAttribution } from "@Utils/searchRecommendationAttribution";

let lastTrackedKey = "";

/**
 * PostHog (and app native) page_viewed for SPA route changes.
 * Uses route `moduleName` as `screen`. Engage uses ae_* params only (not utm_*).
 */
export default function trackRoutePageView(screen: string): void {
  if (typeof window === "undefined" || !screen) return;

  const page_path = window.location.pathname;
  const page_url = window.location.href;
  const dedupeKey = `${screen}|${page_path}|${page_url}`;

  if (dedupeKey === lastTrackedKey) return;
  lastTrackedKey = dedupeKey;

  const engage = getEngageAttributionProps();

  const payload = {
    screen,
    page_path,
    page_url,
    ...engage,
    // Property page reached from the search recommendation section (P1D-5464 FR-41/42).
    ...(getSearchRecommendationAttribution(page_path) || {}),
  };

  posthogEventEmitter({
    action: APP_EVENTS.PAGE_VIEWED,
    category: "route",
    ...payload,
  });

  logAppEvent({
    eventName: APP_EVENTS.PAGE_VIEWED,
    payload,
  });
}
